export default __webpack_public_path__ + "static/media/maternity.b9f7420f.svg";